const DRAFT_KEY = "mubo.dreamDraft";

// This draft stays in the current tab and is never sent until the user posts it.
export const readDreamDraft = () => {
  try {
    return sessionStorage.getItem(DRAFT_KEY) || "";
  } catch {
    return "";
  }
};

export const saveDreamDraft = (title) => {
  try {
    sessionStorage.setItem(DRAFT_KEY, title);
    return true;
  } catch {
    return false;
  }
};

export const clearDreamDraft = () => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch {
    // Posting should still succeed if browser storage is unavailable.
  }
};
